import { ChatbotAnswer } from '../../domain/ChatbotSlice/ChatbotAnswer';
import { ChatbotAskClientMe } from '../../domain/ChatbotSlice/ChatbotAskClientMe';
import ApiWrapperAuthenticated from '../Common/ApiWrapperAuthenticated';

export class ChatbotClientMeRepository extends ApiWrapperAuthenticated<ChatbotAnswer> {
    constructor() {
        super('chatbot/clientme/');
    }

    async ask(message: ChatbotAskClientMe): Promise<ChatbotAnswer | null> {
        return await this.postAuthenticatedCustom({url: '', data: message});
    }
}
